import { render } from "./BarChart.vue?vue&type=template&id=58491e74&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=58491e74&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58491e74"]])

export default __exports__